module.exports = __webpack_public_path__ + "img/bg.11271fd3.png";